<script lang="ts">
  export default {
    name: 'ProgramsCollapseView',
  }
</script>

<script setup lang="ts">
import { RuleViolatingProgram } from '@/services/v2/ClientReadinessService';
import { EllipsisVertical } from 'lucide-vue-next';


defineProps<{
  title: string;
  programs: RuleViolatingProgram[];
  actions: {label: string, value: string}[];
}>();

const emit = defineEmits<{
  action: [action: string, programId: number];
}>();

</script>

<template>
  <div
    class="tw:collapse tw:collapse-arrow tw:overflow-visible tw:rounded-lg tw:bg-base-200 tw:text-lg"
    :class="{ 'tw:collapse-close': programs.length === 0 }"
  >
    <input type="checkbox" />
    <div class="tw:collapse-title tw:flex tw:justify-between">
      <div>{{ title }}</div>
      <div class="tw:text-xl" :class="{ 'tw:text-primary': programs.length > 0 }">
        {{ programs.length }}
      </div>
    </div>
    <div class="tw:collapse-content">
      <table class="tw:table tw:bg-white">
        <tbody>
          <tr v-for="program in programs" :key="program.programId">
            <td>
              <div class="tw:flex tw:items-center tw:gap-2">
                <div class="tw:text-base">
                  {{ program.programName }}
                </div>
              </div>
            </td>
            <td class="tw:text-end">
              <div v-if="actions.length > 0" class="tw:dropdown">
                <div tabindex="0" role="button" class="tw:btn tw:btn-xs">
                  <EllipsisVertical :size="15" />
                </div>
                <ul
                  tabindex="0"
                  class="tw:menu tw:dropdown-content tw:menu-xs tw:z-10 tw:rounded-lg tw:bg-white tw:shadow"
                >
                  <li v-for="action in actions" :key="action.value">
                    <a @click="emit('action', action.value, program.programId)">{{ action.label }}</a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
